import * as angular from 'angular';
import 'angular-ui-router';
import { deskScriptSource, blipCopilotScriptSource } from 'app.constants';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { DeskController } from './DeskController';
import { BlipCopilotController } from './BlipCopilotController';
import DeskView from './DeskView.html';
import BlipCopilotView from './BlipCopilotView.html';
export const deskMfeAllStateName = 'auth.application.detail.attendance.desk.all';
const deskMfeStateName = 'auth.application.detail.attendance.desk';
const deskViews = {
    'content@auth.application.detail': {
        controller: DeskController,
        controllerAs: '$ctrl',
        template: DeskView,
    },
};
const blipCopilotView = {
    'content@auth.application.detail': {
        controller: BlipCopilotController,
        controllerAs: '$ctrl',
        template: BlipCopilotView,
    },
};
const urlMapping = {
    '/desk': deskMfeStateName,
    '/personalizedbreaks': 'auth.application.detail.attendance.desk.personalizedbreaks',
    '/attendance-hours': 'auth.application.detail.attendance.desk.attendancehours',
    '/general-settings': 'auth.application.detail.attendance.desk.generalsettings',
    '/message-template': 'auth.application.detail.attendance.desk.messagetemplate',
    '/rules': 'auth.application.detail.attendance.desk.rules',
    '/rules/create': 'auth.application.detail.attendance.desk.rules.create',
    '/rules/edit': 'auth.application.detail.attendance.desk.rules.edit',
    '/team': 'auth.application.detail.attendance.desk.team',
    '/team/create': 'auth.application.detail.attendance.desk.team.create',
    '/team/edit': 'auth.application.detail.attendance.desk.team.edit',
    '/team/permission': 'auth.application.detail.attendance.desk.team.permission',
    '/survey-dashboard': 'auth.application.detail.attendance.desk.survey-dashboard',
    '/queue-management': 'auth.application.detail.attendance.desk.queueManagement',
    '/queue-management/edit': 'auth.application.detail.attendance.desk.queueManagement.edit',
    '/sales-dashboard': 'auth.application.detail.attendance.desk.salesdashboard',
    '/report': 'auth.application.detail.attendance.desk.report',
    '/monitoring': 'auth.application.detail.attendance.desk.monitoring',
    '/history': 'auth.application.detail.attendance.desk.history',
    '/channels': 'auth.application.detail.attendance.desk.channels',
    '/replies': 'auth.application.detail.attendance.desk.replies',
    '/ia-copilots/lead-score': 'auth.application.detail.attendance.desk.iacopilots',
    '/ia-copilots/care-copilot': 'auth.application.detail.attendance.desk.carecopilot',
    '/blip-copilot': 'auth.application.detail.attendance.desk.blipcopilot',
    '/calls-dashboard': 'auth.application.detail.attendance.desk.callsdashboard',
    '/sla-policy': 'auth.application.detail.attendance.desk.slaPolicy',
    '/metadata-management': 'auth.application.detail.attendance.desk.metadataManagement',
    '/quality-assurance': 'auth.application.detail.attendance.desk.qualityAssurance',
};
export default angular
    .module('desk', ['ui.router', 'shared'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state(deskMfeStateName, {
            url: '/desk',
            views: deskViews,
            onEnter: () => {
                MicroFrontendService.addSource(blipCopilotScriptSource);
                return MicroFrontendService.addSource(deskScriptSource);
            },
        }).state(deskMfeAllStateName, {
            url: '/{path:any}',
            onEnter: ['$state', '$stateParams', 'isAttendanceMenuMfeEnabled', function ($state, $stateParams, isAttendanceMenuMfeEnabled) {
                    if (!isAttendanceMenuMfeEnabled) {
                        const state = urlMapping[`/${$stateParams.path}`] || deskMfeStateName;
                        $state.go(state, $stateParams);
                    }
                }],
        }).state('auth.application.detail.attendance.desk.personalizedbreaks', {
            url: '/personalizedbreaks',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.attendancehours', {
            url: '/attendance-hours',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.generalsettings', {
            url: '/general-settings',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.messagetemplate', {
            url: '/message-template',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.rules', {
            url: '/rules',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.rules.create', {
            url: '/create',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.rules.edit', {
            url: '/edit/:id',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.team', {
            url: '/team',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.team.create', {
            url: '/create',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.team.edit', {
            url: '/edit',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.team.permission', {
            url: '/permission',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.survey-dashboard', {
            url: '/survey-dashboard',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.queueManagement', {
            url: '/queue-management',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.queueManagement.edit', {
            url: '/edit/:id',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.salesdashboard', {
            url: '/sales-dashboard',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.report', {
            url: '/report',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.monitoring', {
            url: '/monitoring',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.history', {
            url: '/history',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.channels', {
            url: '/channels',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.replies', {
            url: '/replies',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.iacopilots', {
            url: '/ia-copilots/lead-score',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.carecopilot', {
            url: '/ia-copilots/care-copilot',
            views: deskViews,
            data: {
                width: '100%',
            },
        })
            .state('auth.application.detail.attendance.desk.blipcopilot', {
            url: '/blip-copilot',
            views: blipCopilotView,
        })
            .state('auth.application.detail.attendance.desk.callsdashboard', {
            url: '/calls-dashboard',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.slaPolicy', {
            url: '/sla-policy',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.metadataManagement', {
            url: '/metadata-management',
            views: deskViews,
        }).state('auth.application.detail.attendance.desk.qualityAssurance', {
            url: '/quality-assurance',
            views: deskViews,
        });
    }]).name;
